import { useMutation, useQueryClient } from '@tanstack/react-query';
import mergeStudies, { MergeStudiesRequest } from '../api/mergeStudies';
import { QUERY_KEY as STUDIES_QUERY_KEY } from './useStudies';

const useMergeStudies = () => {
  const queryClient = useQueryClient();

  const { isLoading: isMerging, mutateAsync: mergeStudiesAsync } = useMutation({
    mutationFn: (request: MergeStudiesRequest) => mergeStudies(request),
    onSuccess: (res) => {
      queryClient.invalidateQueries([STUDIES_QUERY_KEY]);
      return res;
    },
  });

  return { isMerging, mergeStudiesAsync };
};

export default useMergeStudies;
